import { render, staticRenderFns } from "./MonitorsList.vue?vue&type=template&id=067c741f&scoped=true&"
import script from "./MonitorsList.vue?vue&type=script&lang=js&"
export * from "./MonitorsList.vue?vue&type=script&lang=js&"
import style0 from "./MonitorsList.vue?vue&type=style&index=0&id=067c741f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067c741f",
  null
  
)

export default component.exports